import axios from 'axios';

export const MiddlewareAPI = axios.create({
  baseURL: process.env.REACT_APP_URL_BASE_BFF,
  timeout: 40000,
  auth: {
    password: process.env.REACT_APP_CLIENT_SECRET || '',
    username: process.env.REACT_APP_CLIENT_ID || '',
  },
});

export const IdentityAPI = axios.create({
  baseURL: process.env.REACT_APP_URL_IDENTITY_API,
  timeout: 40000,
});

export const PROCEDA_API = axios.create({
  baseURL: process.env.REACT_APP_URL_PROCEDA_API,
  timeout: 40000,
});

export const setIdentityAPIToken = (jwtToken: string): void => {
  IdentityAPI.defaults.headers.common.Authorization = `Bearer ${jwtToken}`;
  MiddlewareAPI.defaults.headers.common.Authorization = `Bearer ${jwtToken}`;
};
